import React from "react";
import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Fade + rise reveal on scroll into view
export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-10% 0px -10% 0px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal. Pass an array of lines.
export const MaskedLines = ({ lines, className = "", lineClassName = "", start = 0.15, stagger = 0.12, animateOnLoad = true }) => {
  const viewProps = animateOnLoad
    ? { animate: "show" }
    : { whileInView: "show", viewport: { once: true } };
  return (
    <motion.div
      className={className}
      initial="hidden"
      {...viewProps}
      transition={{ staggerChildren: stagger, delayChildren: start }}
    >
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            className={`block ${lineClassName}`}
            variants={{
              hidden: { y: "110%" },
              show: { y: "0%", transition: { duration: 1, ease: EASE } },
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </motion.div>
  );
};

// Section label (kicker)
export const SectionLabel = ({ children, dark = false, className = "" }) => (
  <Reveal>
    <div className={`flex items-center gap-4 ${className}`}>
      <span className={`inline-block w-8 h-px ${dark ? "bg-gold" : "bg-gold-2"}`} />
      <span
        className={`text-xs font-bold uppercase tracking-[0.28em] ${
          dark ? "text-gold" : "text-gold-2"
        }`}
        data-testid="section-label"
      >
        {children}
      </span>
    </div>
  </Reveal>
);
